"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bumpSubscriptionIdFor = bumpSubscriptionIdFor;
exports.settlementSaleIdFor = settlementSaleIdFor;
exports.isBumpSubscriptionId = isBumpSubscriptionId;
const BUMP_SUBSCRIPTION_ID_PREFIX = 'subscription:bump:';
function bumpSubscriptionIdFor(saleId, orderBumpId) {
    return `${BUMP_SUBSCRIPTION_ID_PREFIX}${saleId}:${orderBumpId}`;
}
function settlementSaleIdFor(subscriptionId, cycleN) {
    return `invoice:${subscriptionId}:${cycleN}`;
}
function isBumpSubscriptionId(subscriptionId) {
    return subscriptionId?.startsWith(BUMP_SUBSCRIPTION_ID_PREFIX) === true;
}
//# sourceMappingURL=subscription-identifiers.js.map